import { IconButton, IconButtonProps, styled, Tooltip } from "@mui/material";
import { ReactNode } from "react";
import {
  DeleteIcon,
  DisabledDeleteIcon,
  DisabledEditIcon,
  DisableIcon,
  EditIcon,
  EnableIcon,
  PrintIcon,
  ViewIcon,
} from "./Icons";

// Modern action button styling
const StyledIconButton = styled(IconButton)<{
  actionType: "delete" | "edit" | "view" | "print";
}>(({ actionType }) => {
  const colors = {
    view: { hover: 'rgba(100, 116, 139, 0.1)' },
    edit: { hover: 'rgba(213, 142, 78, 0.1)' },
    delete: { hover: 'rgba(239, 68, 68, 0.1)' },
    print: { hover: 'rgba(59, 130, 246, 0.1)' },
  };
  
  return {
    padding: 8,
    borderRadius: 8,
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: colors[actionType]?.hover || 'rgba(0, 0, 0, 0.04)',
      transform: 'scale(1.05)',
    },
  };
});

interface ButtonProps extends IconButtonProps {
  disabledText?: string;
  actionType?: "delete" | "edit" | "view" | "print";
}

function Button({ ...props }: ButtonProps) {
  const handleClick = (e: any) => {
    e.stopPropagation();
    if (!props.onClick) return;
    props.onClick(e);
  };
  return (
    <StyledIconButton
      {...props}
      onClick={handleClick}
      actionType={props.actionType ? props.actionType : "view"}
    >
      {props.children}
    </StyledIconButton>
  );
}

function DisabledButton({
  disabledText,
  children,
}: {
  disabledText?: string;
  children: ReactNode;
}) {
  return (
    <Tooltip title={disabledText || "Disabled"} arrow>
      <span style={{ cursor: "not-allowed", opacity: 0.5, display: 'inline-flex' }}>
        {children}
      </span>
    </Tooltip>
  );
}

export function ViewButton({ disabled, disabledText, ...props }: ButtonProps) {
  if (disabled) {
    return (
      <DisabledButton {...props} disabledText={disabledText}>
        <ViewIcon />
      </DisabledButton>
    );
  }
  return (
    <Button {...props} actionType="view">
      <ViewIcon />
    </Button>
  );
}

export function EditButton({ disabled, disabledText, ...props }: ButtonProps) {
  // if (disabled) {
  //   return (
  //     <DisabledButton
  //       disabledText={disabledText ?? "Default types can not be edited"}
  //     >
  //       <DisabledEditIcon />
  //     </DisabledButton>
  //   );
  // }
  return (
    <Button {...props} actionType="edit">
      <EditIcon />
    </Button>
  );
}

export function DisableButton({
  disabled,
  disabledText,
  ...props
}: ButtonProps) {
  // if (disabled) {
  //   return (
  //     <DisabledButton
  //       disabledText={disabledText ?? "Default types can not be edited"}
  //     >
  //       <DisabledEditIcon />
  //     </DisabledButton>
  //   );
  // }
  return (
    <Button {...props} actionType="edit">
      <DisableIcon />
    </Button>
  );
}

export function EnableButton({
  disabled,
  disabledText,
  ...props
}: ButtonProps) {
  // if (disabled) {
  //   return (
  //     <DisabledButton
  //       disabledText={disabledText ?? "Default types can not be edited"}
  //     >
  //       <DisabledEditIcon />
  //     </DisabledButton>
  //   );
  // }
  return (
    <Button {...props} actionType="edit">
      <EnableIcon />
    </Button>
  );
}
export function PrintButton({ disabled, disabledText, ...props }: ButtonProps) {
  if (disabled) {
    return (
      <DisabledButton
        disabledText={disabledText ?? "Default types can not be edited"}
      >
        <DisabledEditIcon />
      </DisabledButton>
    );
  }
  return (
    <Button {...props} actionType="print">
      <PrintIcon />
    </Button>
  );
}

export function DeleteButton({
  disabled,
  disabledText,
  ...props
}: ButtonProps) {
  if (disabled) {
    return (
      <DisabledButton
        disabledText={disabledText ?? "Default types can not be deleted"}
      >
        <DisabledDeleteIcon />
      </DisabledButton>
    );
  }
  return (
    <Button {...props} actionType="delete">
      <DeleteIcon />
    </Button>
  );
}
